// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* src/App.css */
* {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
}

:root {
  --primary-color: #1e3a8a;
  --primary-light: rgba(30, 58, 138, 0.1);
  --secondary-color: #f8fafc;
  --text-color: #1f2937;
  --light-text: #6b7280;
  --light-border: #e5e7eb;
  --background-color: #f9fafb;
  --white: #ffffff;
  --status-red: #dc2626;
  --status-green: #059669;
  --status-yellow: #d97706;
}

body {
  font-family: 'Roboto', 'Segoe UI', Arial, sans-serif;
  background-color: var(--background-color);
  color: var(--text-color);
  line-height: 1.5;
}

.app {
  display: flex;
  flex-direction: column;
  min-height: 100vh;
}

.main-content {
  flex: 1 1;
  padding: 24px;
  max-width: 1200px;
  margin: 0 auto;
  width: 100%;
}

a {
  color: var(--primary-color);
  text-decoration: none;
}

a:hover {
  text-decoration: underline;
}`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA,gBAAgB;AAChB;EACE,sBAAsB;EACtB,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,wBAAwB;EACxB,uCAAuC;EACvC,0BAA0B;EAC1B,qBAAqB;EACrB,qBAAqB;EACrB,uBAAuB;EACvB,2BAA2B;EAC3B,gBAAgB;EAChB,qBAAqB;EACrB,uBAAuB;EACvB,wBAAwB;AAC1B;;AAEA;EACE,oDAAoD;EACpD,yCAAyC;EACzC,wBAAwB;EACxB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,iBAAiB;AACnB;;AAEA;EACE,SAAO;EACP,aAAa;EACb,iBAAiB;EACjB,cAAc;EACd,WAAW;AACb;;AAEA;EACE,2BAA2B;EAC3B,qBAAqB;AACvB;;AAEA;EACE,0BAA0B;AAC5B","sourcesContent":["/* src/App.css */\n* {\n  box-sizing: border-box;\n  margin: 0;\n  padding: 0;\n}\n\n:root {\n  --primary-color: #1e3a8a;\n  --primary-light: rgba(30, 58, 138, 0.1);\n  --secondary-color: #f8fafc;\n  --text-color: #1f2937;\n  --light-text: #6b7280;\n  --light-border: #e5e7eb;\n  --background-color: #f9fafb;\n  --white: #ffffff;\n  --status-red: #dc2626;\n  --status-green: #059669;\n  --status-yellow: #d97706;\n}\n\nbody {\n  font-family: 'Roboto', 'Segoe UI', Arial, sans-serif;\n  background-color: var(--background-color);\n  color: var(--text-color);\n  line-height: 1.5;\n}\n\n.app {\n  display: flex;\n  flex-direction: column;\n  min-height: 100vh;\n}\n\n.main-content {\n  flex: 1;\n  padding: 24px;\n  max-width: 1200px;\n  margin: 0 auto;\n  width: 100%;\n}\n\na {\n  color: var(--primary-color);\n  text-decoration: none;\n}\n\na:hover {\n  text-decoration: underline;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
